import { cn } from "@/lib/utils";
import HBranchLine from "./HBranchLine";
import type { SectionNavigationGrandChildItemProps } from "./SectionNavigationDialog.types";

const SectionNavigationGrandChildItem = ({
  grandchild,
  isActive,
  onNavigate,
}: SectionNavigationGrandChildItemProps) => {
  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => onNavigate(grandchild.id)}
        className={cn(
          "w-full text-left font-normal hover:text-violet-800 px-3 py-1 text-sm transition-colors relative rounded-xs",
          "focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-violet-500 focus-visible:ring-offset-1",
          isActive ? "text-violet-900 font-medium" : "text-gray-900",
        )}
      >
        <HBranchLine active={isActive} />
        {grandchild.label}
      </button>

      {/* Purple left border segment for active grandchild only */}
      {isActive && (
        <span
          className="absolute left-0 top-0 w-px bg-violet-700 h-full"
          aria-hidden="true"
          style={{ marginLeft: "-1px" }}
        />
      )}
    </div>
  );
};

export default SectionNavigationGrandChildItem;
